app.factory("medicalUtil", function( localStorageAccess ) {
    var _medicalDataNameList = [ "medicalId", "medicalEntry" ,"medicalType", "medicalHeight", "medicalWeight", "medicalFat", "medicalBMI", "medicalWaist", "medicalBasal", "medicalSystolic", "medicalDiastolic", "medicalPulse", "medicalWBC", "medicalRBC", "medicalPlt", "medicalHb", "medicalHt", "medicalTC", "medicalHDL", "medicalLDL", "medicalTG", "medicalSugar", "medicalHbA1c", "medicalGOT", "medicalGPT", "medicalGTP", "medicalALP", "medicalLDH", "medicalBUN", "medicalCRE", "medicalUA" ];
    function _getMedicalDataByEntry( entry ) {
        var mlist = localStorageAccess.getData( "medical" );
        var rs = null;
        if( mlist != null ) {
            for( var i=0; i < mlist.length; i++ ) {
                if( mlist[i].medicalEntry == entry ) {
                    rs = mlist[i];
                    break;
                }
            }
        }
        return rs;
    };
    return {
        "getMedicalCount" : function() {
            var mlist = localStorageAccess.getData( "medical" );
            var cnt = 0;
            if( mlist != null) {
                cnt = mlist.length;
            }
            return cnt;
        },
        "getMedicalData" : function( entry ) {
            var mDataList = {};
            var md = _getMedicalDataByEntry( entry );
            if( md != null ) {
                mDataList = md;
            }
            else {
                for( var i=0; i < getMedicalDataNameList().length; i++ ) {
                    mDataList[ medicalDataNameList[i] ] = "";
                };
                mDataList.medicalId = ( new Date() ).getTime();
                mDataList.medicalType = 0;
            }
            return mDataList;
        },
        "getMedicalDataList" : function() {
            var mlist = localStorageAccess.getData( "medical" );
            if( mlist == null ) {
                mlist = [];
            }
            mlist.sort(
                function( a, b ) {
                    if( a.medicalEntry < b.medicalEntry ) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
            );
            return mlist;
        },
        "getMedicalDataByEntry" : function( entry ) {
            var mlist = localStorageAccess.getData( "medical" );
            var rs = null;
            if( mlist != null ) {
                for( var i=0; i < mlist.length; i++ ) {
                    if( mlist[i].medicalEntry == entry ) {
                        rs = mlist[i];
                        break;
                    }
                }
            }
            return rs;
        },
        "addMedicalData" : function( medicalId, adddata ) {
            var mlist = localStorageAccess.getData( "medical" );
            if( mlist == null ) {
                mlist = [];
            }
            adddata[ "medicalId" ] = medicalId;
            mlist.push( adddata );
            localStorageAccess.setData( "medical", mlist );
        },
        "updMedicalDataById" : function( medicalId, upddata ) {
            var mlist = localStorageAccess.getData( "medical" );
            var rs = null;
            for( var i = 0; i < mlist.length; i++ ) {
                if( mlist[ i ].medicalId == medicalId ) {
                    upddata[ "medicalId" ] = mlist[ i ].medicalId;
                    mlist[ i ] = upddata;
                    break;
                }
            }
            localStorageAccess.setData( "medical", mlist );
        },
        "delMedicalDataByEntry" : function ( entry ) {
            var mlist = localStorageAccess.getData( "medical" );
            var rs = false;
            for( var i = 0 ; i < mlist.length; i++ ) {
                if( mlist[ i ].medicalEntry == entry ) {
                    mlist.splice( i, 1 );
                    localStorageAccess.setData( "medical", mlist );
                    rs = true;
                }
            }
            return rs;
        },
        "createMedicalId" : function() {
            var tpd = new Date();
            return tpd.getTime();
        },
        "sortMedicalDataListByEntryDesc" : function( mlist ) {
            mlist.sort(
                function(a, b) {
                    if(a < b) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
            );
        },
        "calcBMI" : function( wt, ht ) {
            var bmi = null;
            if( wt != null && ht != null && ht > 0 ) {
                bmi = wt/((ht*0.01)*(ht*0.01));
            }
            return bmi;
        },
        "calcBMR" : function( wt, ht, age, gender ) {
            var bmr = null;
            if( wt != null && ht != null && age != null && gender != null ) {
                var ct = { "0" : 0.4235, "1" : 0.9708 };
                bmr = (0.0481*wt+0.0234*ht-0.0138*age-ct[gender])*1000/4.186;
            }
            return bmr;
        }
	};
});
